import {
  ALERT_MESSAGE,
  ALERT_MESSAGE_TYPE,
  AUTH_ME,
  IS_LOGIN,
  PLAN_LIST,
  TOGGLE_THEME,
  CLIENT_AUTH_LOADING,
  CLIENT_AUTH_ERROR,
  VENDOR_AUTH_LOADING,
  VENDOR_AUTH_ERROR,
  VENDOR_SIGNUP_LOADING,
  VENDOR_SIGNUP_ERROR,
  VENDOR_FORGOT_PASSWORD_LOADING,
  VENDOR_FORGOT_PASSWORD_ERROR,
  VENDOR_RESET_PASSWORD_LOADING,
  VENDOR_RESET_PASSWORD_ERROR,
} from "../actions/type";

const theme = localStorage.getItem("defaultTheme")
  ? localStorage.getItem("defaultTheme")
  : "light";

const initialState = {
  defaultTheme: theme,
  authMe: {},
  isLogin: false,
  alertMessage: null,
  alertMessageType: false,
  planList: [],
  clientAuthLoading: false,
  clientAuthError: "",
  vendorAuthLoading: false,
  vendorAuthError: "",
  vendorSignupLoading: false,
  vendorSignupError: "",
  vendorForgotPasswordLoading: false,
  vendorForgotPasswordError: "",
  vendorResetPasswordLoading: false,
  vendorResetPasswordError: "",
};

export default function (state = initialState, action) {
  const { type, payload } = action;
  switch (type) {
    case TOGGLE_THEME:
      return {
        ...state,
        defaultTheme: payload,
      };
    case AUTH_ME:
      return {
        ...state,
        authMe: payload,
      };
    case IS_LOGIN:
      return {
        ...state,
        isLogin: payload,
      };
    case ALERT_MESSAGE:
      return {
        ...state,
        alertMessage: payload,
      };
    case ALERT_MESSAGE_TYPE:
      return {
        ...state,
        alertMessageType: payload,
      };
    case PLAN_LIST:
      return {
        ...state,
        planList: payload,
      };
    case CLIENT_AUTH_LOADING:
      return { ...state, clientAuthLoading: payload };
    case CLIENT_AUTH_ERROR:
      return { ...state, clientAuthError: payload };
    case VENDOR_AUTH_LOADING:
      return { ...state, vendorAuthLoading: payload };
    case VENDOR_AUTH_ERROR:
      return { ...state, vendorAuthError: payload };
    case VENDOR_SIGNUP_LOADING:
      return { ...state, vendorSignupLoading: payload };
    case VENDOR_SIGNUP_ERROR:
      return { ...state, vendorSignupError: payload };
    case VENDOR_FORGOT_PASSWORD_LOADING:
      return { ...state, vendorForgotPasswordLoading: payload };
    case VENDOR_FORGOT_PASSWORD_ERROR:
      return { ...state, vendorForgotPasswordError: payload };
    case VENDOR_RESET_PASSWORD_LOADING:
      return { ...state, vendorResetPasswordLoading: payload };
    case VENDOR_RESET_PASSWORD_ERROR:
      return { ...state, vendorResetPasswordError: payload };
    default:
      return state;
  }
}
